import routesData from './routes.json';
import Homepage from '@/pages/public/Homepage';
import WhyImprove from '@/pages/public/WhyImprove';
import CyberSecurity from '@/pages/public/CyberSecurity';
import Features from '@/pages/public/Features';
import CourseLibrary from '@/pages/public/CourseLibrary';
import Pricing from '@/pages/public/Pricing';
import Contact from '@/pages/public/Contact';
import Blog from '@/pages/public/Blog';
import About from '@/pages/public/About';
import SingleCourse from '@/pages/public/SingleCourse';
import PartnerProgramme from '@/pages/public/PartnerProgramme';
import PrivacyPolicy from '@/pages/public/PrivacyPolicy';
import eula from '@/pages/public/eula';
import UsagePolicy from '@/pages/public/UsagePolicy';
import BusinessCaseBlog from '@/pages/public/blogs/BusinessCaseBlog';
import MobilePhoneLearningBlog from '@/pages/public/blogs/MobilePhoneLearningBlog';
import LearningAndDevelopmentVitalSMEBusinessGrowth from '@/pages/public/blogs/LearningAndDevelopmentVitalSMEBusinessGrowth';
import SMEOutsourceLearningAndDevelopment from '@/pages/public/blogs/SMEOutsourceLearningAndDevelopment';
import OutsourcingCompanyAddPortfolio from '@/pages/public/blogs/OutsourcingCompanyAddPortfolio';
import BenefitsForSME from '@/pages/public/blogs/BenefitsForSME';
import SMECompaniesSucceedThroughOutsourcing from '@/pages/public/blogs/SMECompaniesSucceedThroughOutsourcing';
import Thankyou from '@/pages/public/Thankyou';
import HRIntegration from '@/pages/public/HRIntegration';
import FAQ from '@/pages/public/FAQ';

const components = {
  Homepage,
  WhyImprove,
  CyberSecurity,
  Features,
  CourseLibrary,
  Pricing,
  Contact,
  Blog,
  About,
  SingleCourse,
  PartnerProgramme,
  PrivacyPolicy,
  eula,
  UsagePolicy,
  BusinessCaseBlog,
  MobilePhoneLearningBlog,
  LearningAndDevelopmentVitalSMEBusinessGrowth,
  SMEOutsourceLearningAndDevelopment,
  OutsourcingCompanyAddPortfolio,
  BenefitsForSME,
  SMECompaniesSucceedThroughOutsourcing,
  Thankyou,
  HRIntegration,
  FAQ,
};

const routes = routesData.map((route) => ({
  ...route,
  component: components[route.name.replace(/\s/g, '')] // Match component name with the `name` in JSON
}));

export default routes.map((route) => {
  const meta = {
    public: true,
    onlyLoggedOut: true,
  };
  return { ...route, meta };
});
